
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            this.heroSlider()
            this.productSlider01()
            // this.productSlider02()
            // this.productSlider03()
            this.asideSlider01()
            this.commonSlider()
            // this.pickupSlider()
            // this.eventSlider()

        })
        barba.hooks.after((data) => {
            this.heroSlider()
            this.productSlider01()
            // this.productSlider02()
            // this.productSlider03()
            this.asideSlider01()
            this.commonSlider()
            // this.pickupSlider()
            // this.eventSlider()
        });
        
    }
    
    heroSlider(){
        setTimeout(function(){
            new Swiper ('#hero--slider',{
                loop: true,
                effect :'fade',
                speed:3000,
                allowTouchMove :false,
                simulateTouch:false,
                observer:true,
                autoplay: {
                    delay: 4000
                }
            })
        },1000)
    }
    commonSlider(){
        const common_thumbnails = document.querySelectorAll('.common-slider-thumbnails a');
        const commonSlider = new Swiper('.common-slider', {
            navigation:  {
                nextEl: '.common-slider .swiper-button-next',
                prevEl: '.common-slider .swiper-button-prev',
            },
            on: {
                transitionStart(){
                    var	self = this;
                    for(var i = 0; i <  common_thumbnails.length; i++){
                        common_thumbnails[i].classList.remove('active');
                        common_thumbnails[self.realIndex].classList.add('active');
                    }
                }
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            loop : true
        });
        
        for(var i = 0; i <  common_thumbnails.length; i++){
            commonThumbnailAddEvent( common_thumbnails[i],i);
        }
        function commonThumbnailAddEvent(el,i){
            el.addEventListener('click',function(e){
                e.preventDefault();
                commonSlider.slideTo(i+1);
            })
        }
    }
    productSlider01(){
        new Swiper('.l-aside__product--slider', {
            easing:"linear",
            slidesPerView: 1.5,
            loop: true,
            speed: 2000,
            autoplay: { 
                delay: 400, 
                disableOnInteraction: false,
            },
            loopFillGroupWithBlank: true,
            simulateTouch: false,
            centeredSlides: true,
            allowTouchMove: false,
            spaceBetween: 20,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                }
            }
        })
    }
    // productSlider02(){
    //     new Swiper('.l-aside__product--slider.--product02', {
    //         easing:"linear",
    //         slidesPerView: 1.3,
    //         //spaceBetween: 24,
    //         simulateTouch:true,
    //         centeredSlides: false,
    //         // slidesPerView: 1.3,
    //         // freeMode: true,
    //         scrollbar: {
    //             el: ".swiper-scrollbar.--product02",
    //             draggable: true,
    //         },
    //         spaceBetween: 20,
    //         breakpoints: {
    //             576: {
    //                 slidesPerView: 2,
    //             },
    //             768: {
    //                 slidesPerView: 2.5,
    //             },
    //             992: {
    //                 slidesPerView: 2.4,
    //             }
    //         }
    //     })
    // }
    // productSlider03(){
    //     new Swiper('.l-aside__product--slider.--product03', {
    //         easing:"linear",
    //         slidesPerView: 1.3,
    //         //spaceBetween: 24,
    //         simulateTouch:true,
    //         centeredSlides: false,
    //         // slidesPerView: 1.3,
    //         // freeMode: true,
    //         scrollbar: {
    //             el: ".swiper-scrollbar.--product03",
    //             draggable: true,
    //         },
    //         spaceBetween: 20,
    //         breakpoints: {
    //             576: {
    //                 slidesPerView: 2,
    //             },
    //             768: {
    //                 slidesPerView: 2.5,
    //             },
    //             992: {
    //                 slidesPerView: 2.4,
    //             }
    //         }
    //     })
    // }
    asideSlider01(){
        const breakPoint = 991;
        let mySwiper ;
        let mySwiperBool ;

            window.addEventListener('load',()=>{
            if( breakPoint < window.innerWidth){
                mySwiperBool = false;
                }else{
                    createSwiper();
                    mySwiperBool = true;
                }
            },false);

            window.addEventListener('resize',()=>{
                if( breakPoint < window.innerWidth && mySwiperBool){
                    mySwiper.destroy(false,true);
                    mySwiperBool = false;
                }else if( breakPoint >= window.innerWidth && !(mySwiperBool)){
                    createSwiper();
                    mySwiperBool = true;
                }
            },false);

            function createSwiper() {
                mySwiper = new Swiper('.l-aside__blog--slider', {
                easing:"linear",
                slidesPerView: 1.3,
                //spaceBetween: 24,
                simulateTouch:true,
                centeredSlides: false,
                // slidesPerView: 1.3,
                // freeMode: true,
                scrollbar: {
                    el: ".swiper-scrollbar.--blog",
                    draggable: true,
                },
                spaceBetween: 20,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2.5,
                    },
                    992: {
                        slidesPerView: 2.4,
                    }
                }
            });
        }
    }
}